import React, {useContext, useEffect, useState} from 'react';
import {Box, Grid, Tooltip, Typography} from "@deere/fuel-react";
import "../assets/Campaigns.scss";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import {isDatePastForRatings} from "../shared/utils";
import {
    DECREASE,
    FINAL,
    INCREASE, SCORE_OVERRIDE,
    MID_YEAR,
    PROJECTED,
    YEAR_END
} from "../shared/Constants";
import TrendingDownIcon from "@material-ui/icons/TrendingDown";
import {RatingsOverrideModal} from "../shared/modal/RatingsOverrideModal";
import {UserContext} from "./Main";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import {Chip} from "@material-ui/core";
import {ClassificationGuidelinesPopOver} from "./ClassificationGuidelinesPopOver";

export const RatingsOverallSummaryCard = ({
    classifications,
    ratingsPerfSummary,
    summaryTotal,
    reasons,
    isEdit,
    onOverrideSave,
    ratingPeriod,
    totalOverrideObj
}) => {
    const userInfo = useContext(UserContext);
    const [supplierClass, setSupplierClass] = useState("");
    const [currentFYPeriod, setCurrentFYPeriod] = useState(null);
    const [previousFYPeriod, setPreviousFYPeriod] = useState(null);
    const [ratingType, setRatingType] = useState("Projected");
    const [ratingPerfType, setRatingPerfType] = useState("");
    const [previousScore, setPreviousScore] = useState(0);
    const [currentScore, setCurrentScore] = useState(0);
    const [reasonValue, setReasonValue] = useState("");

    useEffect(() => {
        const currentPeriodObject = ratingsPerfSummary.filter(item => item.isCurrent)[0]
        const previousPeriodObject = ratingsPerfSummary.filter(item => !item.isCurrent)[0]
        const isDateDueInPast = isDatePastForRatings(currentPeriodObject.dueDate)

        const currentTotalScore = currentPeriodObject.totalUpdatedScore !== null ? currentPeriodObject.totalUpdatedScore : currentPeriodObject.totalScore;
        const currentScore = isDateDueInPast ? currentTotalScore : summaryTotal

        setRatingType(isDateDueInPast ? FINAL : PROJECTED)
        setCurrentFYPeriod(`${currentPeriodObject.period === 2 ? YEAR_END : MID_YEAR} ${currentPeriodObject.fiscalYear}`)
        setPreviousFYPeriod(`${previousPeriodObject.period === 2 ? YEAR_END : MID_YEAR} ${previousPeriodObject.fiscalYear}`)
        setRatingPerfType(currentScore >= previousPeriodObject.totalScore ? INCREASE : DECREASE)
        setPreviousScore(previousPeriodObject.totalScore)

        const projectedClass = classifications.filter(item => {
            return currentScore >= item.totalMinPoints && currentScore <= item.totalMaxPoints
        })

        if (projectedClass?.length > 0) {
            setSupplierClass(projectedClass[0].classificationDesc)
        } else {
            setSupplierClass("Unknown")
        }
        setCurrentScore(currentScore ?? "N/A")

        return () => {
            setRatingPerfType("")
            setPreviousScore(0)
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ratingsPerfSummary, summaryTotal]);

    useEffect(() => {
        const reasonValue = (totalOverrideObj && isEdit) ? reasons.filter(item => item.id === totalOverrideObj.reasonId)[0].reason : "";
        setReasonValue(reasonValue)

        return () => {
            setReasonValue("")
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reasons, totalOverrideObj]);


    return (
        <Box ml={8}>
            <Grid container>
                <Grid item xs={12}>
                    <Grid item xs={12}>
                        <Box mt={4}>
                            <Typography fontWeight="semibold" display="inline"
                                variant="h5">
                                <span style={{"backgroundColor":"#FFDE00"}}>{ratingType}</span> {currentFYPeriod} Ratings{" "}
                            </Typography>
                        </Box>
                    </Grid>


                    <Grid item xs={12}>
                        <Box mt={2}>
                            <Grid direction={"row"} container alignItems="center" spacing={2}>
                                <Grid item>
                                    <Typography size="2xl" fontWeight="semibold" display="inline">
                                        {supplierClass} ({currentScore})
                                    </Typography>
                                </Grid>
                                <ClassificationGuidelinesPopOver />
                            </Grid>
                            {totalOverrideObj && ratingPeriod !== 0 &&
                                <Box ml={2} display="inline-flex">
                                    <Tooltip
                                        title={`${reasonValue}: ${totalOverrideObj.overridePoints} pts: ${totalOverrideObj.comments}`}
                                        placement="bottom-start"
                                    >
                                        <Chip size="small" icon={<InfoOutlinedIcon style={{fill: "#005DB1"}} />}
                                            label={SCORE_OVERRIDE}
                                            style={{backgroundColor: "#C4DAED", fontWeight: 600, borderRadius: ".5rem"}} />
                                    </Tooltip>

                                </Box>
                            }
                            {userInfo && userInfo.isCriteriaAdmin && ratingPeriod !== 0 &&
                                <RatingsOverrideModal
                                    reasons={reasons}
                                    totalOverrideObj={totalOverrideObj}
                                    isEdit={isEdit}
                                    onSave={onOverrideSave} />
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12}>

                        <Typography
                            sx={{display: "inline-flex"}}
                            color="tertiary"
                            size="sm"
                        >
                            {ratingPerfType} from {previousFYPeriod} ({previousScore}){" "}
                            {ratingPerfType === INCREASE ?
                                <TrendingUpIcon
                                    fontSize="small"
                                    style={{marginLeft: ".25rem", color: "#367c2b"}}
                                />
                                :
                                <TrendingDownIcon fontSize="small"
                                    style={{marginLeft: ".25rem", color: "#c21020"}} />
                            }
                        </Typography>
                    </Grid>
                </Grid>

            </Grid>
        </Box>
    )
}
